import { getUploader, type UploadResult } from "@phup/phup.js/release/phup";
import HttpClient from "./network";
import { Response } from "../models/response";
import { OnSiteApi } from "../apis/onsite";

interface PhotoInfraSession {
  key: string;
  userId: string;
}

async function getSessionKey() {
  return new Response<PhotoInfraSession>(
    await HttpClient.request(OnSiteApi.photoInfraSession()),
  );
}

export async function uploadImage(imageFile: File): Promise<string> {
  const uploadImageUrl = process.env.REACT_APP_IMAGE_UPLOAD_URL!;
  const imageDeliveryUrl = process.env.REACT_APP_DELIVERY_URL!;
  const sessionResponse = await getSessionKey();

  return new Promise((resolve, reject) => {
    const uploader = getUploader(
      "SIMPLE",
      (result: UploadResult) => {
        if (result.code !== "IMAGE" || !result.thumbnail) {
          reject(new Error(result.code || "UPLOAD_FAILED"));
        } else {
          resolve(`${imageDeliveryUrl}${result.thumbnail}`);
        }
      },
      {
        domain: uploadImageUrl,
        getSessionKey: (cb) => {
          cb(sessionResponse.data.key);
        },
        userId: sessionResponse.data.userId,
        sslEnabled: window.location.protocol === "https:",
        autorotate: true,
      },
    );
    try {
      uploader.upload({ file: imageFile, imageFileName: imageFile.name });
    } catch (err) {
      console.error("Image upload failed:", err);
      reject(err);
    }
  });
}
